<template>
  <div class="features">
    <div class="feature-details">
      <div>
        <el-row>
          <div class="roboto" style="color: #3e6161">Customize</div>
          <div
            style="
              padding-top: 10px;
              font-family: 'Roboto';
              font-weight: 400;
              font-size: 18px;
              line-height: 21px;
              color: #292929;
            "
          >
            Improve your ZHR by customizing the system to your clinic's needs.
          </div>
        </el-row>
        <el-row style="padding-top: 48px" :gutter="0">
          <el-col :span="8">
            <div class="bigbox">
              <img src="@/assets/questionnaire.svg" class="imgbig" />

              <h3 class="feature-title">Questionnaire</h3>

              <p class="feature-description">
                Customizing questionnaires or patient intake forms enables the
                provider to get the information best suited for their clinic's
                needs.
              </p>
            </div>
          </el-col>

          <el-col :span="8">
            <div style="padding-bottom: 26px">
              <div class="smallbox">
                <div v-if="!showChart">
                  <img src="@/assets/chart.svg" class="imgsmall" />

                  <div class="flex justify-between items-center feature-title">
                    <div>Chart Template</div>

                    <el-button
                      type="text"
                      class="inline-block my-1"
                      style="color: #3e6161;padding-right: 15px;"
                      @click="showChart = true"
                    >
                      <span class="material-icons-outlined">east</span>
                    </el-button>
                  </div>
                </div>

                <div v-if="showChart" class="feature-detail">
                  <div>
                    Providers will find customizable templates in charting.
                    Creating templates in charting allows the provider to add
                    information quickly in the encounter note.

                    <div class="flex float-right">
                      <el-button
                        type="text"
                        class="inline-block"
                        style="color: #3e6161;"
                        @click="showChart = false"
                      >
                        <span class="material-icons-outlined" >west</span>
                      </el-button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div style="padding-bottom: 26px">
              <div class="smallbox">
                <div v-if="!showVital">
                  <img src="@/assets/vitals.svg" class="imgsmall" />

                  <div class="flex justify-between items-center feature-title">
                    <div>Vitals</div>
                    <el-button
                      type="text"
                      class="inline-block"
                      style="color: #3e6161;padding-right: 15px"
                      @click="showVital = true"
                    >
                      <span class="material-icons-outlined">east</span>
                    </el-button>
                  </div>
                </div>

                <div v-if="showVital" class="feature-detail">
                  <div>
                    Create vitals that fit your clinic's needs. There is no
                    limit to how many vitals you add. You can track their vitals
                    on a line graph from visit to visit.
                  </div>

                  <div class="flex float-right">
                    <el-button
                      type="text"
                      class="inline-block"
                      style="color: #3e6161"
                      @click="showVital = false"
                    >
                      <span class="material-icons-outlined">west</span>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="padding-left: 362px; padding-top: 100px">
        <el-row>
          <div class="roboto" style="color: #3e6161">Create</div>
          <div
            style="
              padding-top: 10px;
              font-family: 'Roboto';
              font-weight: 400;
              font-size: 18px;
              line-height: 21px;
              color: #292929;
            "
          >
            Optimize your ZHR by creating tasks, tags, and product bundles that
            make your system run more efficiently.
          </div>
        </el-row>
        <el-row style="padding-top: 48px" >
          <el-col :span="11">
            <div class="bigbox">
              <img src="@/assets/task.svg" class="imgbig" />

              <div class="feature-title">Tasks</div>
              <div class="feature-description">
                The task feature helps complete tasks inside the clinic to
                optimize patient care. On top of optimizing patient care, it
                also helps keep the clinic organized and is a great way to
                quickly communicate within the clinic.
              </div>
            </div>
          </el-col>

          <el-col :span="8">
            <div style="padding-bottom: 26px">
              <div class="smallbox">
                <div v-if="!showTag">
                  <img src="@/assets/tag.svg" class="imgsmall" />
                  <div class="feature-title flex justify-between items-center">
                    <div>Tags</div>
                    <el-button
                      type="text"
                      class="inline-block"
                      style="color: #3e6161;padding-right: 15px"
                      @click="showTag = true"
                    >
                      <span class="material-icons-outlined">east</span>
                    </el-button>
                  </div>
                </div>

                <div v-else class="feature-detail">
                  <div>
                    The provider can free type any word to create a tag for the
                    patient. Tags allow providers to group patients with similar
                    health concerns to diagnose each patient better.

                    <div class="flex float-right">
                      <el-button
                        type="text"
                        class="inline-block"
                        style="color: #3e6161;"
                        @click="showTag = false"
                      >
                        <span class="material-icons-outlined">west</span>
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="smallbox">
              <div v-if="!showProduct">
                <img src="@/assets/product.svg" class="imgsmall" />
                <div class="feature-title flex justify-between items-center">
                  <div>Product Bundle</div>
                  <el-button
                    type="text"
                    class="inline-block"
                    style="color: #3e6161;padding-right: 15px"
                    @click="showProduct = true"
                  >
                    <span class="material-icons-outlined">east</span>
                  </el-button>
                </div>
              </div>

              <div v-else class="feature-detail">
                <div>
                  Create custom bundles with ICD codes, tests, procedures, and
                  drugs in settings. This will increase billing and save time
                  when charting.
                </div>

                <div class="flex float-right">
                  <el-button
                    type="text"
                    class="inline-block"
                    style="color: #3e6161"
                    @click="showProduct = false"
                  >
                    <span class="material-icons-outlined">west</span>
                  </el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="padding-top: 200px">
        <el-row>
          <div class="roboto" style="color: #3e6161">Communicate</div>
          <div
            style="
              padding-top: 10px;
              font-family: 'Roboto';
              font-weight: 400;
              font-size: 18px;
              line-height: 21px;
              color: #292929;
            "
          >
            Streamline your communication with your patients all inside your
            ZHR.
          </div>
        </el-row>
        <el-row style="padding-top: 48px; padding-bottom: 215px">
          <el-col :span="8">
            <div style="padding-bottom: 26px">
              <div class="smallbox">
                <div v-if="!showIntegration">
                  <img src="@/assets/integrations.svg" class="imgsmall" />
                  <div class="feature-title flex justify-between items-center">
                    <div>Integrations</div>
                    <el-button
                      type="text"
                      class="inline-block"
                      style="color: #3e6161;padding-right: 15px"
                      @click="showIntegration = true"
                    >
                      <span class="material-icons-outlined">east</span>
                    </el-button>
                  </div>
                </div>

                <div v-else class="feature-detail">
                  <div>
                    Telemedicine is made easier with Zoom integrated right into
                    your EHR. Google Calendar integration will keep you up to
                    date on all appointments.
                    <div class="flex float-right">
                      <el-button
                        type="text"
                        class="inline-block"
                        style="color: #3e6161"
                        @click="showIntegration = false"
                      >
                        <span class="material-icons-outlined">west</span>
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="smallbox">
              <div v-if="!showPatientPortal">
                <img src="@/assets/patient_portal.svg" class="imgsmall" />
                <div class="feature-title flex justify-between items-center">
                  <div>Patient Portal</div>
                  <el-button
                    type="text"
                    class="inline-block"
                    style="color: #3e6161;padding-right: 15px"
                    @click="showPatientPortal = true"
                  >
                    <span class="material-icons-outlined">east</span>
                  </el-button>
                </div>
              </div>

              <div v-else class="feature-detail">
                <div>
                  The patient portal allows for communication to work both ways
                  between provider and patient. Patients can request
                  appointments, and add vitals and medications they take.

                  <div class="flex float-right">
                    <el-button
                      type="text"
                      class="inline-block"
                      style="color: #3e6161"
                      @click="showPatientPortal = false"
                    >
                      <span class="material-icons-outlined">west</span>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="bigbox">
              <img src="@/assets/scheduling.svg" class="imgbig" />

              <div class="feature-title">Scheduling</div>
              <div class="feature-description">
                The provider can create recurring appointments, assign patient
                intake forms, send appointment confirmation and reminders, all
                from the scheduling box in seconds.
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showChart: false,
      showVital: false,

      showTag: false,
      showProduct: false,

      showIntegration: false,
      showPatientPortal: false,
    };
  },
};
</script>

<style scoped>
.features {
  background-image: url("../assets/ccc_back.svg");
}

.feature-details {
  margin-left: 140px;
  padding-top: 150px;
}

.feature-detail{
  padding: 15px 15px 0px 22px;
  font-size: 16px;
  color: #000000;
}

.roboto {
  font-family: "Roboto Serif";
  font-weight: 600;
  font-size: 40px;
  line-height: 47px;
}
.bigbox {
  color: #3e6161;
  max-width: 386px;
  max-height: 296px;
  width: 386px;
  height: 296px;
  border-radius: 6px;
  background-color: #ffffff;
  z-index: 1;
}
.smallbox {
  color: #3e6161;
  width: 386px;
  height: 135px;
  max-width: 386px;
  max-height: 135px;
  border-radius: 6px;
  background-color: #ffffff;
  padding-bottom: 26px;
}

.feature-title {
  margin: 10px 0 0 23px;
  font-size: 20px;
}

.feature-description {
  margin: 10px 10px 10px 23px;
  font-size: 16px;
  color: #000000;
}
.imgbig{
  margin-bottom:-10px;
  padding: 28px 0 0 8px
}

.imgsmall{
  margin-bottom:-20px;
  padding: 11px 0 0 8px
}

</style>
